import { openBlock, createElementBlock, normalizeStyle, createElementVNode, toDisplayString, createCommentVNode } from 'vue';

var script = {
  name: "vue-loading",
  props: {
    loadingMessage: {
      type: String,
      default: ""
    },
    containerStyle: {
      type: String,
      default: ""
    },
    spinnerStyle: {
      type: String,
      default: 'width: 30px; height: 30px;'
    },
    textStyle: {
      type: String,
      default: ''
    }
  }
};

var _hoisted_1 = ["textContent"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: "vue-loading",
    style: normalizeStyle($props.containerStyle)
  }, [createElementVNode("span", {
    class: "spinner-border spinner-border-sm align-middle",
    role: "status",
    "aria-hidden": "true",
    style: normalizeStyle($props.spinnerStyle)
  }, null, 4), $props.loadingMessage && $props.loadingMessage != '' ? (openBlock(), createElementBlock("span", {
    key: 0,
    class: "loading-text mx-2",
    style: {},
    textContent: toDisplayString($props.loadingMessage)
  }, null, 8, _hoisted_1)) : createCommentVNode("", true)], 4);
}

script.render = render;

export { script as s };
